import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-avatar-iniciales',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './avatar-iniciales.component.html',
  styleUrl: './avatar-iniciales.component.css',
})
export class AvatarInicialesComponent {
  @Input() nombre: string = '';
  @Input() apellido: string = '';
  @Input() activo!: boolean;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  iniciales: string = '';
  mostrarIcono: boolean = false;
  isHovered: boolean = false;
  ngOnInit(): void {
    const tieneNombre = this.nombre?.trim().length > 0;
    const tieneApellido = this.apellido?.trim().length > 0;

    if (tieneNombre) {
      const primera = this.nombre.charAt(0);
      const segunda = this.apellido.charAt(0);
      this.iniciales = `${primera}${segunda}`.toUpperCase();
      this.mostrarIcono = false;
    } else {
      this.mostrarIcono = true;
    }
  }

  nombreCompleto(): string {
    return `${this.nombre} ${this.apellido}`.trim() || 'Usuario sin nombre';
  }
}
